module.exports = __webpack_public_path__ + "media/src/img/contacts-icon-9e51a093bd83d0238b43d5ca275ffe6e.svg";